import Center from 'shared/components/Center'
import styled from 'styled-components'

import Button from 'shared/components/Button'
import { Feedback } from 'shared/components/Feedback'
import dimensions from 'shared/styles/dimensions'
import { colors } from 'shared/styles/colors'
import Page from 'shared/components/Page'

export const ContainerForm = styled.div`
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;

  width: 100%;

  input {
    margin: ${dimensions.spaces.small}px 0;
    max-width: 513px;
  }
`

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;

  @media (max-width: 320px) {
    position: relative;
    bottom: -5.5rem;
    right: -45px;
  }
  @media (max-height: 669px) {
    position: relative;
    bottom: -1.5rem;
  }
`

export const ContainerInput = styled.div`
  width: 100%;
  max-width: 513px;

  display: flex;
  align-items: center;
`

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
`

export const StyledFeedback = styled(Feedback)`
  padding: 65px 0px;
  width: 100%;
`

export const StyledCenter = styled(Center)`
  position: absolute;
`

export const Icon = styled.div`
  color: ${colors.gray};
  width: 16px;
  height: 16px;
  margin-left: -2rem;
`

export const HelperMessage = styled.span`
  font-weight: bold;
  font-size: 18;
  color: ${colors.red};
`

export const ButtonShowPassword = styled.button`
  display: flex;
  align-items: center;

  border: none;
  background: transparent;
`

export const ContainerAtencao = styled.div`
  display: flex;
  margin-top: 30px;
  line-height: 1.5;

  & > div:last-child {
    margin-left: 5px;
  }
`
export const Container = styled.div`
  width: 100%;
  max-width: 513px;
`

export const StyledPage = styled(Page)`
  height: unset;
`
